{
	"title": "Otisk",
	"backTitle": "Zpět",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Německo"
		},
		"contact": {
			"telephone": "Telefon: +49 6221 481-0",
			"telefax": "Fax: +49 6221 481-13553",
			"email": "E-mail: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Sídlo společnosti: Heidelberg",
			"commercialRegister": "Obchodní rejstřík: Mannheim, HRB 741878",
			"managingDirectors": "Jednatelé:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
